
	import { ref, defineComponent, computed, watch, reactive, toRaw, onMounted } from 'vue'
	import { useStore } from 'vuex'
	import { createCallAccount, modCallAccount } from '../request'
	import { message } from 'ant-design-vue'
	import { modalState } from '../config'
	import moment from 'moment'
	import deepClone from 'library/functions/deepClone'
	import _ from 'lodash'
	import { getCallLine } from '../../business/request'
	import { supplierOptions } from '../config'
	interface Form {
		supplierType: number
		wayType: number
		configJson: {
			callLine?: string
			accountName?: string
			password?: string
			accountId?: string
			pbx?: string
			secretKey?: string
			host?: string
            proxyUrl?: string
            url?: string
            serviceNo?: string
            serviceNoVoice?: string
            account?: string
            pass?: string
            appId?: string
            appToken?: string
            appName?: string
		}
	}
	export default defineComponent({
        props: {
            type: {
                type: String,
                default: "add"
            },
            value: {
                type: Object,
                default: () => ({})
            }
        },
        emits: ['close'],
		setup(props, { emit }) {
			const store = useStore()
			const formRef = ref()
			const packageOptions = ref([])
			const signatureInputValue = ref('')
            const isView = computed(() => props.type === 'view')
            const isEdit = computed(() => props.type === 'edit')

            const callLines = ref([])

			const form = reactive<Form>({
				supplierType: 0,
				wayType: 0,
				configJson: {
					callLine: '',
					accountName: '',
					password: '',
					accountId: '',
					pbx: '',
                    proxyUrl: '',
					secretKey: '',
					host: '',
                    serviceNo: '',
                    serviceNoVoice: '',
                    url: '',
                    account: '',
                    pass: '',
                    appId: '',
                    appToken: '',
                    appName: ''
				}
			})

            const handleParams = (obj) => {
                let params = {}
                if (form.supplierType === 0) {
                    params = {callLine: obj.callLine}
                } else if (form.supplierType === 1) {
                    params = {
                        accountName: obj.accountName,
                        password: obj.password,
                        accountId: obj.accountId,
                        secretKey: obj.secretKey,
                        host: obj.host,
                    }
                    if (form.wayType === 0) {
                        Object.assign(params, {
                            pbx: obj.pbx,
                        })
                    } else if (form.wayType === 3) {
                        Object.assign(params, {
                            proxyUrl: obj.proxyUrl,
                        })
                    } else if (form.wayType === 4) {
                        Object.assign(params, {
                            serviceNo: obj.serviceNo,
                            serviceNoVoice: obj.serviceNoVoice,
                        })
                    }
                }
                Object.assign(params, {
                    url: obj.url,
                    account: obj.account,
                    pass: obj.pass,
                })
                return {}
            }

            const callLineOptions = ref([
                {
                    label: '双呼回显',
                    value: 0
                },
            ])
			const init = () => {
				if (props.type !== 'add') {
					Object.assign(form, {
						supplierType: props.value.supplierType?.id
					})
                    changeSupplierType(props.value.supplierType?.id)
                    Object.assign(form, {
				        wayType: props.value.wayType?.id,
					})
					Object.assign(form.configJson, props.value.configJson ? JSON.parse(props.value.configJson) : {})
				}
			}
            const createRuleItem = (type, message) => {
                return {
                    required: true,
                    type,
                    message
                }
            }
			const rules = reactive({
				supplierType: [createRuleItem('number', '请选择供应商类型')],
				wayType: [createRuleItem('number', '请选择外呼模式')],
				configJson: {
                }
			})
            
            const handleRules = () => {
                // 朱雀
                if (form.supplierType === 0) {
                    rules.configJson = {
                        callLine: [createRuleItem('string', '请选择外呼线路')]
                    }
                } else if (form.supplierType === 1) {
                    rules.configJson = {
                        accountName: [createRuleItem('string', '请输入线路帐号')],
                        password: [createRuleItem('string', '请输入密码')],
                        accountId: [createRuleItem('string', '请输入account')],
                        secretKey: [createRuleItem('string', '请输入secretKey')],
                        host: [createRuleItem('string', '请输入请求域名')],
                    }
                    if (form.wayType === 0) {
                        Object.assign(rules.configJson, {
                            pbx: [createRuleItem('string', '请输入pbx')],
                        })
                    } else if (form.wayType === 3) {
                        Object.assign(rules.configJson, {
                            proxyUrl: [createRuleItem('string', '请输入proxyUrl')],
                        })
                    } else if (form.wayType === 4) {
                        Object.assign(rules.configJson, {
                            serviceNo: [createRuleItem('string', '请输入文本服务号')],
                            serviceNoVoice: [createRuleItem('string', '请输入文件服务号')],
                        })
                    }
                } else if (form.supplierType === 2) {
                    rules.configJson = {
                        appId: [createRuleItem('string', '请输入appId')],
                        appToken: [createRuleItem('string', '请输入appToken')],
                        appName: [createRuleItem('string', '请输入appName')]
                    }
                }
            }

            watch([() => form.supplierType, () => form.wayType], () => {
                handleRules()
            }, {immediate: true})

			const loading = ref<boolean>(false)
			const afterClose = () => {
				emit('close')
			}

            const changeSupplierType = (val) => {
                const item = supplierOptions.find(item => item.value === val)
                if (item) {
                    callLineOptions.value = item.children
                    form.wayType = item.children[0].value
                }
            }

			const onSubmit = () => {
				formRef.value.validate().then(async () => {
					let formValue = deepClone(form)
					formValue.configJson = JSON.stringify(formValue.configJson)
					loading.value = true
					try {
                        if (props.type === 'add') {
                            await createCallAccount(formValue)
                        } else if (props.type === 'edit') {
                            await modCallAccount({num: props.value.num, ...formValue})
                        }
						loading.value = false
						afterClose()
						message.success('保存成功')
					} catch (e) {
						loading.value = false
					}
				}).catch(() => {
                    console.log(2323)
                })
			}

			onMounted(async () => {
				init()
                const res = await getCallLine({})
				callLines.value = res.data
			})

			return {
				form,
				store,
				loading,
				rules,
				onSubmit,
				afterClose,
				signatureInputValue,
				formRef,
				packageOptions,
				modalState,
				supplierOptions,
				callLineOptions,
                callLines,
                isView,
                createRuleItem,
                changeSupplierType,
                isEdit
			}
		}
	})
